import React from "react";

const BiddingOverMessage = () => (
  <div className="bg-[#CA0000] text-md lg:text-[1vw] shadow tracking-wider text-white text-center p-[0.7vw] font-bold">
    Preliminary Bidding is Over for this vehicle
  </div>
);

export default BiddingOverMessage;
